import { request } from '@/utils/request';

// 手机号验证码登录
export function userLogin(data) {
  return request.post(
    {
      url: '/admin/login/phone',
      data,
    },
    { withToken: false },
  );
}

// 获取当前管理员信息
export function getAdminInfo() {
  return request.get({
    url: '/api/v1/admin/details',
  });
}

// 发送短信验证码，参数：{ phone }
export function getVerificationCode(data) {
  return request.post(
    {
      url: '/send/sms',
      data,
    },
    { withToken: false },
  );
}

// 退出登录
export function userLogout() {
  return request.get({
    url: '/admin/logout',
  });
}

// 用户注册
export function userRegister(data) {
  return request.post({
    url: '/admin/register',
    data,
  });
}

// 修改密码
export function updateOwnPassword(data) {
  return request.post({
    url: '/api/v1/admin/updateOwnPassword',
    data,
  });
}
